import { tv } from 'tailwind-variants';

export const alertColors = ['info', 'success', 'warning', 'danger'];

export const theme = tv({
    slots: {
        base: 'relative flex w-full shrink-0 items-start gap-2.5 overflow-hidden border-b p-4',
        icon: 'shrink-0',
        title: 'text-sm font-bold',
        content: 'text-sm',
        actions: 'mt-2 flex shrink-0 flex-wrap items-start gap-1.5',
        dismissButton: '-m-1.5 inline-flex cursor-pointer items-center gap-1.5 p-1.5',
    },
    variants: {
        color: {
            info: {
                base: 'border-[#172CB6] bg-[#D9E6FF] text-[#172CB6]',
            },
            success: {
                base: 'border-[#115B0C] bg-[#D2FFC5] text-[#115B0C]',
            },
            warning: {
                base: 'border-[#82280C] bg-[#FFECD3] text-[#82280C]',
            },
            danger: {
                base: 'border-red-200 bg-red-50/50',
            },
        },
        orientation: {
            vertical: '',
            horizontal: '',
        },
    },
    defaultVariants: {
        color: 'info',
        orientation: 'vertical',
    },
});

export default theme;
